var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useRef, useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
function usePrevious(value) {
    var ref = useRef();
    // Store current value in ref
    useEffect(function () {
        ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}
var getColors = function (props) {
    var _a = props.theme.v2.colors.input, color = _a.color, bgColor = _a.bgColor, borderColor = _a.borderColor, placeholderColor = _a.placeholderColor, focusBorderColor = _a.focusBorderColor;
    var errorColor = props.theme.v2.colors.error;
    return "\n    " + (color ? "--inp-color: " + color + ";" : '') + "\n    " + (bgColor ? "--inp-bg-color: " + bgColor + ";" : '') + "\n    " + (borderColor ? "--inp-border-color: " + borderColor + ";" : '') + "\n    " + (placeholderColor ? "--inp-placeholder-color: " + placeholderColor + ";" : '') + "\n    " + (focusBorderColor ? "--inp-focus-border-color: " + focusBorderColor + ";" : '') + "\n    " + (props.hasError ? " --inp-border-color: " + errorColor + ";--inp-focus-border-color:" + errorColor + ";" : '') + "\n  ";
};
var StyledInput = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n  margin-right: 8px;\n  border-radius: 8px;\n  border: solid 1px var(--inp-border-color);\n\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  text-align: center;\n  ", ";\n\n  :last-child {\n    margin-right: 0;\n  }\n  \n  :focus,\n  :hover {\n    border-color: var(--inp-focus-border-color);\n    outline: none;\n  }\n\n  :focus {\n    border-color: var(--inp-focus-border-color);\n  }\n  "], ["\n  width: 48px;\n  height: 48px;\n  margin-right: 8px;\n  border-radius: 8px;\n  border: solid 1px var(--inp-border-color);\n\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  text-align: center;\n  ", ";\n\n  :last-child {\n    margin-right: 0;\n  }\n  \n  :focus,\n  :hover {\n    border-color: var(--inp-focus-border-color);\n    outline: none;\n  }\n\n  :focus {\n    border-color: var(--inp-focus-border-color);\n  }\n  "])), function (props) { return getColors(props); });
export function SingleOTPInputComponent(props) {
    var focus = props.focus, autoFocus = props.autoFocus, rest = __rest(props, ["focus", "autoFocus"]);
    var inputRef = useRef(null);
    var prevFocus = usePrevious(!!focus);
    useLayoutEffect(function () {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);
    return React.createElement(StyledInput, __assign({ ref: inputRef }, rest));
}
var SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
var templateObject_1;
